import { render, staticRenderFns } from "./bigTitle.vue?vue&type=template&id=c0d22c52&scoped=true"
import script from "./bigTitle.vue?vue&type=script&lang=js"
export * from "./bigTitle.vue?vue&type=script&lang=js"
import style0 from "./bigTitle.vue?vue&type=style&index=0&id=c0d22c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d22c52",
  null
  
)

export default component.exports